import i18n from 'shared/i18n';

$(document).ready(() => {
  if ($('#warn-on-back-button').length > 0) {
    enableNavigationConfirmation();
    browserBackButtonHandler();
  }
});

// Allows for elements that arrive after doc ready
$(document).ajaxComplete(() => {
  if ($('#warn-on-back-button').length > 0) {
    browserBackButtonHandler();
  }
});

function enableNavigationConfirmation() {
  window.onbeforeunload = function () {
    return i18n.t('shared.areYouSureYouWantToLeaveThisPage', { ns: 'common' });
  };
}

function browserBackButtonHandler() {
  // disable onbeforeunload for legal navigation links
  const legalNavigationCss = ['a', '.no-back-warning'];

  legalNavigationCss.forEach((css) => {
    $(css).unbind('mousedown');
    $(css).unbind('mouseup');
    $(css).on('mousedown', () => {
      window.onbeforeunload = null;
    });
  });
}
